import { render, staticRenderFns } from "./duoTile.vue?vue&type=template&id=a05510c4&"
import script from "./duoTile.vue?vue&type=script&lang=js&"
export * from "./duoTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports